import { Globals } from "./globals.js";
import defaults from "./defaults.js";

export class Adjustable2 {
    constructor(inValue, minValue = Number.MIN_SAFE_INTEGER, maxValue = Number.MAX_SAFE_INTEGER, wrap = false) {
        // values and limits
        this.referenceValue = inValue;
        this.lowerLimit = minValue;
        this.upperLimit = maxValue;
        this.wrap = wrap;
        // Modifier stack
        this.referenceModifiers = [];
        this.offsetModifiers = [];
        this.referenceValue = inValue;
        this.offsetValue = 0;
        this.externalUpdate = false;
        // Housekeeping
        this.cleanUpRate = 20 + (Math.random() * 20); // when to look for expired modifiers
        this.cleanUpCount = this.cleanUpRate;
        // calculated values
        this.speed = 0;
        this.lastValue = 0;
        this.lastUpdate = Date.now();
        this.nextAction = "next";
    }

    addReferenceModifier(modifier) {
        this.referenceModifiers.push(modifier);
    }

    addOffsetModifier(modifier) {
        this.offsetModifiers.push(modifier);
    }

    removeModifier(modifier) {
        if (!modifier) { // not an error
            return;
        }
        for (let i = 0; i < this.referenceModifiers.length; i++) {
            if (this.referenceModifiers[i] === modifier) {
                this.referenceModifiers[i].stop();
                this.referenceModifiers.splice(i,1);
                break;
            }
        }
        for (let i = 0; i < this.offsetModifiers.length; i++) {
            if (this.offsetModifiers[i] === modifier) {
                this.offsetModifiers[i].stop();
                this.offsetModifiers.splice(i,1);
                break;
            }
        }
    }

    removeOffsetModifiers() {
        this.offsetModifiers = [];
    }

    reference() {
        return this.referenceValue;
    }

    value() {
        return this.referenceValue + this.offsetValue;
    }

    offset() {
        return this.offsetValue;
    }

    speed() {
        return this.speed;
    }

    setValue(value) {
        this.referenceValue = value;
        this.externalUpdate = true;
    }

    forceValue(value) {
        this.referenceValue = value;
    }

    stop() {
        // We call stop() in case there are callbacks waiting
        for (let i = 0; i < this.referenceModifiers.length; i++) {
            this.referenceModifiers[i].stop();
        }
        this.referenceModifiers = [];
        for (let i = 0; i < this.offsetModifiers.length; i++) {
            this.offsetModifiers[i].stop();
        }
        this.offsetModifiers = [];
        this.offsetValue = 0;
        this.speed = 0;
    }

    applyModifiers(modList, now, current) {
        let value = current;
        let updated = false;
        let skipCount = 0;
        for (let i = 0; i < modList.length; i++) {
            if (modList[i].update(now, value)) {
                if (skipCount) {
                    skipCount -= 1;
                } else {
                    value = modList[i].getValue();
                    switch(modList[i].nextAction) {
                        case "next":
                            // that's fine
                            break;
                        case "end":
                            skipCount = 9999;
                            break;
                        case "skip":
                            skipCount = 1;
                            break;
                        case "zero":
                            value = 0;
                            break;
                        default:
                            // internal error
                            break;
                    }
                    updated = true;
                }
                modList[i].nextAction = "next";
            }
        }
        // reset next action to default
        return [value, updated];
    }

    updateValue() {
        const now = Date.now();
        let updated = this.externalUpdate;
        this.externalUpdate = false;
        let [refValue, refChanged] = this.applyModifiers(this.referenceModifiers, now, this.referenceValue);
        if (refChanged) { updated = true; }
        // Clamp to given limits
        if (refValue < this.lowerLimit) {
            if (this.wrap) {
                refValue = this.upperLimit;
            } else {
                refValue = this.lowerLimit;
            }
        } else if (refValue > this.upperLimit) {
            if (this.wrap) {
                refValue = this.lowerLimit;
            } else {
                refValue = this.upperLimit;
            }
        }
        this.referenceValue = refValue;
        // Calculate instantaneous speed in pixels per second
        this.speed = (1000 / (now - this.lastUpdate)) * (this.referenceValue - this.lastValue);

        const [offValue, offChanged] = this.applyModifiers(this.offsetModifiers, now, 0);
        if (offChanged) { updated = true; }
        this.offsetValue = offValue;
        // Housekeeping
        if (this.cleanUpCount < 1) {
            this.cleanUp();
            this.cleanUpCount = this.cleanUpRate;
        } else {
            this.cleanUpCount -= 1;
        }
        return updated;
    }

    cleanUp() {
        // navigate the arrays backwards to preserve index values
        for (let i = this.referenceModifiers.length - 1; i >= 0; i--) {
            if (this.referenceModifiers[i].expired) {
                this.referenceModifiers.splice(i,1);
            }
        }
        for (let i = this.offsetModifiers.length - 1; i >= 0; i--) {
            if (this.offsetModifiers[i].expired) {
                this.offsetModifiers.splice(i,1);
            }
        }
    }
}
